import UserService from 'services/UserService';
import { constants } from 'utils/constants';

class UserAdapter extends UserService {
  logout() {
    window.location.href = '/auth/logout';
  }

  getInfo() {
    return super.getInfo().then((res) => {
      let notifications = [];
      let parameters = {};
      let restrictedMode = false;
      if (res.Notifications && res.Notifications.length) {
        notifications = res.Notifications.map((n) => {
          restrictedMode = restrictedMode || constants.REDIRECT_TO_SUBSCRIPTION === n.ActionID;
          return { actionId: n.ActionID, actionData: n.ActionData };
        });
      }

      if (res.Parameters) {
        parameters = res.Parameters;
      }

      return { email: res.email, notifications, restrictedMode, parameters: parameters };
    });
  }

  register(userData, venueRegisters) {
    return super
      .register(
        { Country: userData.country, Company: userData.company, Phone: userData.phoneNumber, ...userData },
        venueRegisters
      )
      .then((res) => {
        return { subscribeUserId: res.UserID, subscribeCost: res.Price };
      });
  }

  getQuestion(token) {
    return super.getQuestion(token).then((res) => ({
      question: res.Question
    }));
  }

  getUserDetails() {
    return super.getUserDetails().then((res) => ({
      firstName: res.FirstName,
      lastName: res.LastName,
      email: res.Email,
      phoneNumber: res.Phone,
      company: res.Company,
      country: res.Country
    }));
  }

  saveUserDetails(userDetails) {
    return super.saveUserDetails({
      FirstName: userDetails.firstName,
      LastName: userDetails.lastName,
      Email: userDetails.email,
      Phone: userDetails.phoneNumber,
      Company: userDetails.company,
      Country: userDetails.country
    });
  }
}

const instance = new UserAdapter();

export default instance;



// WEBPACK FOOTER //
// ./src/adapters/UserAdapter.js